// TODO refactor

export const useFamilyShadowMember = () => {
  const profile = useProfileStore();
  const context = useContextStore();
  const user = useUserStore();
  const avatarUrl = computed(() => {
    return profile.mediaAvatar.urlCompressed;
  });

  const name = computed(() => {
    return user.firstname;
  });

  const firstname = computed(() => {
    return user.firstname;
  });

  const id = computed(() => {
    return context.memberId;
  });
  return {
    avatarUrl,
    name,
    id,
    firstname,
  };
};
